module.exports = __webpack_public_path__ + "img/A14_19410001-003.7f931a05.jpg";